import { Box, Flex } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import styled from "styled-components"

import Image from "components/landing/image"
import Textarea from "components/landing/textarea"
import { retry } from "helpers/application"
import { getUrlProps } from "helpers/landing"

const ResponsiveVideo = loadable(() =>
  retry(() => import("areas/landing/elements/landing-responsive-video"))
)

const Container = styled(Flex).attrs((props) => ({
  alignItems: { widescreen: "center" },
  containWide: true,
  flexDirection: { _: "column", desktop: "row" },
  gap: { _: "20px", large: 5 },
  justifyContent: "space-between",
  mx: "auto",
  px: { _: 2, tablet: 4, widescreen: "60px" },
  py: { _: 4, widescreen: "60px" },
  ...props,
}))``

const LandingFeatureImageBox = ({ element, lazyload }) => {
  const {
    data: { media_position, url },
    image,
    style,
    video,
  } = element
  const urlProps = getUrlProps(url, element.anchor_name || element.id)

  const media = video ? (
    <ResponsiveVideo lazyload={lazyload} video={video} />
  ) : image ? (
    <Image
      containerStyle={style?.image_container_style}
      image={image}
      lazyload={lazyload}
    />
  ) : null

  const mediaBlock = media ? (
    url ? (
      <Box {...urlProps}>{media}</Box>
    ) : (
      media
    )
  ) : null

  return (
    <Box {...style?.block_style}>
      <Container {...style?.container_style}>
        {mediaBlock && media_position !== "right" && mediaBlock}
        <Box flex={{ desktop: "0 0 50%" }} {...style?.text_container_style}>
          {element.textarea && (
            <Textarea
              element={element.textarea}
              style={element.textarea?.style}
            />
          )}
        </Box>
        {mediaBlock && media_position === "right" && mediaBlock}
      </Container>
    </Box>
  )
}

LandingFeatureImageBox.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingFeatureImageBox
